import type { ReactNode } from 'react';
import type {
  BacklogItemFilterKey,
  DatetimeFilterKeys,
  ItemFilterKey,
  PicklistFilterKeys,
  ResourceFilterKey,
  StringFilterKeys,
  TeamFilterKey,
  TeamsFilterKey,
} from '@/lib/api/types/itemFilters';
import {
  datetimeItemFilterSchema,
  picklistItemFilterSchema,
  stringItemFilterSchema,
} from '@/lib/zod-schemas/itemFilterSearchSchema';

export const picklistItemFilterKeys = Object.keys(
  picklistItemFilterSchema.shape,
) as PicklistFilterKeys[];

export const datetimeItemFilterKeys = Object.keys(
  datetimeItemFilterSchema.shape,
) as DatetimeFilterKeys[];

export const stringItemFilterKeys = Object.keys(stringItemFilterSchema.shape) as StringFilterKeys[];

export type FilterOption = {
  label: string;
  value: string | number;
  icon?: ReactNode;
  component?: ReactNode;
};

export type FilterKey =
  | ItemFilterKey
  | BacklogItemFilterKey
  | ResourceFilterKey
  | TeamFilterKey
  | TeamsFilterKey;

export interface ItemFilterConfig<TFilterKey extends FilterKey = FilterKey> {
  key: TFilterKey;
  label: string;
  icon?: ReactNode;
}

export type ItemFilterConfigMap<TFilterKey extends FilterKey = FilterKey> = Partial<
  Record<TFilterKey, ItemFilterConfig<TFilterKey>>
>;
